import { render, staticRenderFns } from "./detail-inventory-item.vue?vue&type=template&id=66c21971&"
import script from "./detail-inventory-item.vue?vue&type=script&lang=js&"
export * from "./detail-inventory-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports